const ProfileImageUploadStatus = {
  FAILED: 'FAILED',
  PROCESSING: 'PROCESSING',
};

export default ProfileImageUploadStatus;
